import Component from "@glimmer/component";
import { computed } from "@ember/object";
import PluginOutlet from "discourse/components/plugin-outlet";
import concatClass from "discourse/helpers/concat-class";
import lazyHash from "discourse/helpers/lazy-hash";
import { longDate } from "discourse/lib/formatter";
import { and } from "discourse/truth-helpers";
import { i18n } from "discourse-i18n";

export const activityTypes = ["day", "week", "month", "year", "all_time"];

export default class CircleMemberStats extends Component {
  @computed(
    ...activityTypes.map((type) => `args.model.category.topics_${type}`)
  )
  get activityStats() {
    const stat =
      activityTypes.find(
        (type) => this.args.model.category[`topics_${type}`] > 0
      ) || "all_time";

    return i18n(`discourse_circles.circle.topics_stats.${stat}`, {
      count: this.args.model.category[`topics_${stat}`],
    });
  }

  @computed("model.created_at")
  get createdAt() {
    return longDate(this.model.created_at);
  }

  <template>
    <div class="circles-card__stats">
      <PluginOutlet
        @name="circles-card-stats"
        @outletArgs={{lazyHash model=@model}}
      >
        <div class="circles-card__stats-item" data-stat-type="members">
          {{i18n
            "discourse_circles.circle.about.members"
            count=@model.member_group.user_count
          }}
        </div>
        <div class="circles-card__stats-item" data-stat-type="topics">
          <span>{{this.activityStats}}</span>
        </div>
        {{#if @model.category.unreadTopics}}
          <div class="circles-card__stats-item" data-stat-type="unread_topics">
            <a
              href={{@model.category.unreadUrl}}
              title={{i18n
                "topic.unread_topics"
                count=@model.category.unreadTopics
              }}
              class="badge unread-topics badge-notification"
            >
              {{i18n
                "filters.unread.lower_title_with_count"
                count=@model.category.unreadTopics
              }}
            </a>
          </div>
        {{/if}}
        {{#if @model.category.newTopics}}
          <div class="circles-card__stats-item" data-stat-type="new_topics">
            <a
              href={{@model.category.newUrl}}
              title={{i18n "topic.new_topics" count=@model.category.newTopics}}
              class="badge new-topics badge-notification"
            >
              {{i18n
                "filters.new.lower_title_with_count"
                count=@model.category.newTopics
              }}
            </a>
          </div>
        {{/if}}
        {{#each @model.customFields as |field|}}
          {{#if (and field.value field.displayOnCard)}}
            <div
              class={{concatClass "circles-card__stats-item" field.type}}
              data-stat-type="custom-field"
              data-custom-field-type={{field.type}}
            >
              <span class="circles-card__stats-item-name">
                {{field.name}}
              </span>
              <span class="circles-card__stats-item-value">
                {{field.value}}
              </span>
            </div>
          {{/if}}
        {{/each}}
      </PluginOutlet>
    </div>
  </template>
}
